import {API_DRIVER} from "../config/axios";

const getImagesRequestUrl = (endpointUrl: string) => {
    return `/api/images${endpointUrl}`
}

const ImageService = {
    fetchImages: () => {
        return API_DRIVER.get(getImagesRequestUrl(``))
    },
    createImage: (formData: FormData) => {
        return API_DRIVER.post(getImagesRequestUrl(``), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    },
    deleteImage: (imageId: string) => {
        return API_DRIVER.delete(getImagesRequestUrl(``), {
            params: {
                image_id: imageId
            }
        })
    },
}

export default ImageService
